import { useEffect } from "react"
import { baseUrl } from "../../../../Config"

const Concilia = ({ votes }) => {

    useEffect(() => {
        var popoverTriggerList = [].slice.call(document.querySelectorAll('.voting-cage [data-bs-toggle="popover"]'))
        popoverTriggerList.map(function (popoverTriggerEl) {
            return new bootstrap.Popover(popoverTriggerEl) // eslint-disable-line
        })
    }, [])

    return <>
        <div className="voting-cage">
            <div className="voters">
                { votes.map(vote => (
                    <img key={vote.id} src={`${baseUrl}/members/${vote.photo}`} className="authorimg" alt="Author Avatar" data-bs-toggle="popover" data-bs-placement="top" data-bs-html="true" data-bs-trigger="hover focus" data-bs-content={`${vote.name}`} />
                ))}

                { votes.length === 0 && (
                    <p className="mb-0">Sin datos</p>
                )}
            </div>
        </div>
    </>
}

export default Concilia